export default __webpack_public_path__ + "static/mobile-first-header-b49029a4e1214ab2d8f40b7847a892b4.jpg";